export const setupOnboarding = {
  piezas: {
    confirmacion: { etiqueta: "Confirmação", larga: "Confirmação de reserva", porque: "Está a ser usada a configuração geral da sua conta, não uma própria deste alojamento." },
    bienvenida: { etiqueta: "Boas-vindas", larga: "Mensagem de boas-vindas", porque: "Neste momento sai a mensagem de boas-vindas padrão, que não é a sua." },
    checkin: { etiqueta: "Check-in", larga: "Envio do check-in", porque: "Neste momento sai à hora padrão, que pode não ser a que lhe convém." },
    horas: { etiqueta: "Horários", larga: "Hora de entrada e saída", porque: "Sem os seus horários, quando o hóspede pergunta respondem-lhe com os padrão." },
    cerradura: { etiqueta: "Acesso", larga: "Fechadura e acesso", porque: "O hóspede chega à porta e não sabe como abrir." },
    servicios: { etiqueta: "Serviços", larga: "Serviços do alojamento", porque: "Nem o motor de reservas nem o agente sabem o que oferece." },
    politicas: { etiqueta: "Regras", larga: "Políticas e regras", porque: "O hóspede aceita regras padrão, não as suas." },
  },
  titular: {
    listo: "Está tudo pronto",
    unoAMedias: "O seu alojamento está meio configurado",
    variosAMedias: "Os seus alojamentos estão meio configurados",
    casi: "Falta-lhe pouco",
  },
  consecuencia: {
    bienvenida: "Entretanto os seus hóspedes recebem a mensagem de boas-vindas padrão, que não é a sua.",
    cerradura: "Entretanto há hóspedes que chegariam à porta sem saber como abrir.",
    politicas: "Entretanto os seus hóspedes aceitam regras padrão, não as suas.",
    generico: "Entretanto usam-se as configurações padrão, não as suas.",
  },
  explicacion: {
    listoUno: "O seu alojamento já pode receber hóspedes.",
    listoVarios: "Os seus {n} alojamentos já podem receber hóspedes.",
    ajustesFinos: "As configurações finas — tarifas, canais, experiências — esperam por si em cada anúncio quando quiser.",
    faltaUno: "Falta 1 alojamento por terminar.",
    faltanVarios: "Faltam {n} alojamentos por terminar.",
  },
  resumen: {
    unAlojamiento: "1 alojamento",
    nAlojamientos: "{n} alojamentos",
    unoPorPreparar: "1 por preparar",
    nPorPreparar: "{n} por preparar",
    listos: "{listos} prontos",
  },
  anillo: {
    rotulo: "configurado",
    ariaCorta: "{n}% configurado",
    ariaLarga: "{n}% da configuração concluída",
  },
  cifras: {
    listos: "prontos ·",
    ajustes: "configurações feitas",
    ariaAjustes: "{hechas} de {total} configurações feitas",
    marcador: "{hechas} de {total}",
  },
  ventana: {
    titulo: "Fechar este aviso?",
    texto: "Deixará de aparecer no painel, mesmo que lhe falte algo por configurar.",
    notaAntes: "Recupera-o quando quiser em",
    notaRuta: "Personalizar → Mostrar o aviso de configuração",
    cancelar: "Cancelar",
    ocultar: "Fechar",
  },
  acciones: {
    verQueFalta: "Ver o que falta",
    buscar: "Procurar alojamento",
    sinResultados: "Nenhum alojamento pendente se chama assim.",
    verClaro: "Ver em claro",
    verOscuro: "Ver em escuro",
    ampliar: "Ampliar",
    ampliarAria: "Ampliar o aviso",
    minimizar: "Minimizar",
    minimizarAria: "Minimizar o aviso",
    entendido: "Entendido",
    entendidoAria: "Entendido, fechar o aviso",
    ocultar: "Fechar",
    ocultarAria: "Fechar o aviso de configuração",
    empezar: "Começar",
    continuar: "Continuar",
    hecho: "feito",
    teToca: "É a sua vez:",
    unidades: "{n} unidades",
  },
};
